<template>
  <div class="concentrator-list" v-loading="loading">
    <div class="head_body">
      <el-form ref="form" :model="pageInfo" class="search_head">
        <el-row :gutter="20" class="list-head">
          <el-col :span="4">
            <el-form-item label="集控编号">
              <el-input v-model="pageInfo.number" placeholder="请输入设备识别号" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="策略">
              <el-select
                placeholder="选择策略"
                v-model="pageInfo.stg_id"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="t in strategyList"
                  :key="t.id"
                  :label="t.strategy_name"
                  :value="t.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="状态">
              <el-select
                clearable
                placeholder="选择状态"
                v-model="pageInfo.ste"
                style="width: 100%"
              >
                <el-option
                  v-for="(t,index) in filterSteList(steList)"
                  :key="index"
                  :label="t"
                  :value="index+1"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="回路状态">
              <el-select
                clearable
                placeholder="选择回路状态"
                v-model="pageInfo.loop_ste"
                style="width: 100%"
              >
                <el-option
                  v-for="(t,index) in filterSteList(loopSteType)"
                  :key="index"
                  :label="t"
                  :value="index+1"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :offset="6" :span="2" class="search-btn-box">
            <el-button type="primary" size="small" @click="headSearch"><svg-icon name="search"></svg-icon>搜索</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="h20"></div>
    <div class="con-body">
      <div class="control-group">
        <div class="group-left">
          <el-button
            type="primary"
            size="small"
            @click="openEditWin('create')"
            class="insert-btn"
            ><svg-icon name="add-plus"></svg-icon>添加</el-button
          >
        </div>
        <div class="group-right">
          <el-button
            type="primary"
            size="small"
            @click="concentratorContorls(1)"
            >一键全开</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="concentratorContorls(0)"
            >一键全关</el-button
          >
        </div>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%"
        ref="table"
        :row-key="getRowKey"
        @selection-change="selectionDevice"
        >
        <el-table-column type="selection" :selectable="checkNoSelect" :reserve-selection="true" width="80">
        </el-table-column>
        <el-table-column prop="number" label="设备编号" align="center"></el-table-column>
        <el-table-column prop="name" label="设备名称" align="center"></el-table-column>
        <el-table-column prop="strategy_name" label="当前策略" align="center"></el-table-column>
        <el-table-column prop="equipment_model" label="设备型号" align="center"></el-table-column>
        <el-table-column prop="install_location" label="安装地点" width="220">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :content="scope.row.install_location" placement="top">
              <div class="text-ellipsis">
                <span>{{scope.row.install_location}}</span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="设备状态" width="140" align="center" sortable> 
          <template slot-scope="scope">
            <i :class="scope.row.ste==1?'valuegreen':'valuered'"></i>
            <span>{{ steList[scope.row.ste] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="回路控制">
          <template slot-scope="scope">
            <el-button type="primary" @click="openLampLoop(scope.row)" size="small" class="td-btn-small">回路控制</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="edit" label="编辑" width="180">
          <template slot-scope="scope">
            <div class="table-last">
              <!--ste：1在线 2离线 -->
              <!--ms：1手动 2自动 -->
              <template v-if="scope.row.ste==1"> 
                <span v-if="scope.row.ms==1" @click="recoveryWin(scope.row)" class="blue pointer mar-r10">恢复策略</span>
                <span else class="blue pointer mar-r10">　　　　</span>
              </template>
              <template v-else>
                <span @click="viewReason(scope.row.last_ping)" class="blue pointer mar-r10">查看原因</span>
              </template>
              <span @click="openEditWin(scope.row)" class="blue pointer mar-r10">编辑</span>
              <span @click="delItem(scope.row.id)" class="blue pointer">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>

    <!-- 编辑设备信息弹窗 -->
    <el-dialog
      class="dialog860"
      :title="dialogTitle"
      :visible.sync="dialogVisible">
      <el-form
        :model="editOne"
        :rules="editOneRule"
        ref="editOneRef"
      >
        <div v-show="editOne.step==1" class="form-info">
          <el-row :gutter="20" class="item-list">
            <el-col :span="12">
              <el-form-item label="集控编号" prop="number">
                <el-input v-model="editOne.number" placeholder="请输入集控编号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="集控别名" prop="name">
                <el-input v-model="editOne.name" placeholder="请输入集控别名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="选择型号" prop="equipment_model">
                <el-select
                  clearable
                  placeholder="请选择集控型号"
                  v-model="editOne.equipment_model"
                  style="width: 100%"
                >
                <el-option
                  v-for="(t,index) in modelList"
                  :key="index"
                  :label="t"
                  :value="t"
                ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="策略">
                <el-select
                  placeholder="请选择策略"
                  v-model="editOne.stg_id"
                  style="width: 100%"
                >
                  <el-option :key="0" label="暂无策略" :value="0"></el-option>
                  <el-option
                    v-for="t in strategyList"
                    :key="t.id"
                    :label="t.strategy_name"
                    :value="t.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="安装地址" prop="install_location">
                <el-input v-model="editOne.install_location" class="address" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="经纬度" class="lnglat-input">
                <el-input v-model="editOne.longitude" @input="onInput()"></el-input>
                <el-input v-model="editOne.latitude" @input="onInput()"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div class="map-box">
                <amap :nowlng="editOne.longitude" :nowlat="editOne.latitude" @mapDing="getCoordinate" />
              </div>
            </el-col>
          </el-row>
        </div>
        <div v-show="editOne.step==2" class="form-info">
          <div class="edit-table">
            <ul class="t-head">
              <li class="bh">编号</li>
              <li class="loop">回路</li>
              <li class="time">绑定设备类型</li>
              <li class="time">选择绑定设备</li>
            </ul>
            <div v-if="editOne.loop_device_json&&editOne.loop_device_json.length>0" v-for="itemIndex in [0, 1, 2, 3, 4, 5]" :key="itemIndex" class="item-box">
              <div class="item" v-if="editOne.loop_device_json[itemIndex]">
                <div class="bh">{{itemIndex+1}}</div>
                <div class="loop">
                  回路{{editOne.loop_device_json[itemIndex].loop_number}}
                </div>
                <div class="time">
                  <el-select
                    placeholder="请选择绑定设备类型"
                    v-model="editOne.loop_device_json[itemIndex].bind_type"
                    style="width: 100%"
                    @change="changeType($event, itemIndex)"

                  >
                    <el-option
                      v-for="(t,i) in deviceTypeList"
                      :key="i"
                      :label="t"
                      :value="i"
                    ></el-option>
                  </el-select>
                </div>
                <div class="time">
                  <el-select
                    filterable
                    placeholder="请选择绑定设备"
                    v-model="editOne.loop_device_json[itemIndex].bind_device_id"
                    style="width: 100%"
                  >
                    <el-option :key="0" :label="'暂无'" :value="0"></el-option>
                    <el-option
                      v-if="editOne.loop_device_json[itemIndex].device_list.length"
                      v-for="t in editOne.loop_device_json[itemIndex].device_list"
                      :key="t.lamp_id"
                      :label="t.name+'('+t.number+')'"
                      :value="t.lamp_id"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>

          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <template v-if="editOne.step==1">
          <el-button class="cancel-btn" size="medium" @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" size="medium" @click="groupNext(2)">下一步</el-button>
        </template>
        <template v-if="editOne.step==2"> 
          <el-button class="cancel-btn" size="medium" @click="editOne.step=1">上一步</el-button>
          <el-button v-if="editType === 'create'" type="primary" size="medium" @click="createItem">确定</el-button>
          <el-button v-if="editType === 'update'" type="primary" size="medium" @click="updateItem">确定</el-button>
        </template>
      </div>
    </el-dialog>

    <!-- 一键开关灯-->
    <div v-if="deviceControl.visible" class="box_control_bg ws-control"></div>
    <div v-if="deviceControl.visible" class="box_control device-control">
      <div class="box_body">
        <div class="box_con">
          <div class="box_title">{{ deviceControl.title }}</div>
          <div v-if="deviceControl.cmdState>1" class="right-close" @click="deviceControlClose"><i class="el-icon-close"></i></div>
          <!-- cmdState:  0.未发送执行  1.已发送命令  2.已完成  -->
          <div v-if="deviceControl.deviceList.length" class="device-control-list">
            <div class="item-one" v-for="(item, index) in deviceControl.deviceList" :key="index">
              <div class="item-one-pad">
                <div class="item-icon"><img src="@/assets/images/concentrator-icon.png" /></div>
                <div class="item-title">回路{{item.loop_number}}</div>
                <div class="item-cmd">
                  <span v-if="deviceControl.cmdState==0" class="blue">准备执行</span>
                  <span v-if="deviceControl.cmdState==1" class="blue">执行中...</span>
                  <span v-if="deviceControl.cmdState==2" class="green">{{deviceControl.type?'开连通-成功':'关断开-成功'}}</span>
                  <span v-if="deviceControl.cmdState==3" class="red">{{deviceControl.type?'开连通-失败':'关断开-失败'}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="box-footer">
          <el-button v-if="deviceControl.cmdState>1" @click="deviceControlClose" class="cancel-btn" size="medium">关 闭</el-button>
          <el-button v-if="deviceControl.cmdState==0" type="primary" size="medium">准备中...</el-button>
          <el-button v-if="deviceControl.cmdState==1" type="primary" size="medium">执行中...</el-button>
          <el-button v-if="deviceControl.cmdState==2" type="primary" @click="deviceControlClose" size="medium">执行完成</el-button>
          <el-button v-if="deviceControl.cmdState==3" type="primary" @click="deviceControlClose" size="medium">执行失败</el-button>
        </div>

      </div>
    </div>

    <!-- 恢复策略 -->
    <el-dialog v-if="recoveryData.visible" class="dialog750" title="恢复策略" :visible.sync="recoveryData.visible">
      <div class="recovery-Stategy-box">
        <div v-if="recoveryData.stg_id" class="item">该设备目前是{{ msType[recoveryData.ms] }}模式，您是否恢复如下集控策略?</div>
        <div v-else class="item">该设备目前是{{ msType[recoveryData.ms] }}模式，未配置策略！</div>
        <div class="item item2">
          <div class="name-select">
            <el-select
              placeholder="请选择策略"
              v-model="recoveryData.new_stg_id"
              style="width: 100%"
            >
              <el-option :key="0" label="暂无策略" :value="0"></el-option>
              <el-option
                v-for="t in strategyList"
                :key="t.id"
                :label="t.strategy_name"
                :value="t.id"
              ></el-option>
            </el-select>
          </div>
          <div v-if="recoveryData.stg_id" class="stategy_tip"> &lt;&lt; 请选择您要恢复的策略！</div>
          <div v-else class="stategy_tip"> &lt;&lt; 请给该设备选择策略！</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="box-footer">
          <el-button class="cancel-btn" size="medium" @click="recoveryData.visible=false">取消</el-button>
          <el-button type="primary" size="medium" @click="setRecoveryStrategy(recoveryData.id)">确定</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 查看原因 -->
    <div
      class="box_control_bg"
      v-if="reasonData.visible"
      @click="reasonData.visible=false"
    ></div>
    <div v-if="reasonData.visible" class="box_control reason-box">
      <div class="box_body">
        <div class="box_con">
          <div class="box_title"><i class="el-icon-message-solid"></i><span>查看离线原因</span></div>
          <div class="con-text">
            <div class="item-title">请您先自检如下操作:</div>
            <div class="item">1）该设备是否接入电源<br/>2）天线是否接入，信号是否正常</div>
            <div class="item-heart" v-if="reasonData.last_ping">该设备最后一次心跳时间为: {{reasonData.last_ping}}</div>
            <div class="item-heart" v-else>该设备最后一次心跳时间为: 无</div>
            <div class="item-title">平台建议:</div>
            <div class="item">由于最后一次心跳时间距现在较短，平台对在线条件校验严格，建议您观察1天后，再联系销售经理</div>
          </div>
        </div>
        <div class="box-footer">
          <el-button type="primary" @click="reasonData.visible=false" size="medium">知道了</el-button>
        </div>
      </div>
    </div>

    <!--回路控制-->
    <el-dialog
      class="big-dialog"
      :title="lampLoop.name +' | 回路控制'"
      :visible.sync="lampLoop.dialogVisible"
      v-if="lampLoop.dialogVisible"
    >
      <concentrator-loop
        ref="lampLoop"
        :id="lampLoop.id"
        @closeMethod="closeLampLoop"
      ></concentrator-loop>
      <div slot="footer" class="dialog-footer">
        <div class="box-footer">
          <el-button class="cancel-btn" size="medium" @click="lampLoop.dialogVisible=false">取消</el-button>
          <el-button type="primary" size="medium" @click="lampLoop.dialogVisible=false">完成</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import store from '@/store'
import strategyApi from "@/api/concentrator/strategy"
import concentratorApi from "@/api/concentrator/concentrator";
import concentratorLoop from "@/components/light/concentratorLoop";
import amap from '@/components/addMap'
export default {
  components: {
    concentratorLoop,
    amap
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      deviceTypeList: ['暂无', 'mqtt', 'zigbee', 'lora', 'cat', 'plc'],
      modelList: ['TH6500','TH6600'],
      steList: ['', '在线', '离线'],
      loopSteType: ['', '开启', '关闭'],
      msType: ['', '手动', '自动'],
      strategyList: [],
      tableData: [],
      pageInfo: {
        stg_id: '',
        number: '',
        ste: '',
        loop_ste: '',
        page: 1,
        pageSize: 10,
      },
      cnt_all: 0,
      editOneRule: {
        number: [{ required: true, message: "请输入集控编号", trigger: "blur" }],
        name: [{ required: true, message: "请输入集控别名", trigger: "blur" }],
        equipment_model: [{ required: true, message: "请输入设备型号", trigger: "blur" }]
      },
      editType: -1,
      devSelect: [],
      editOne: {
        id: '',
        step: 1,
        number: '',
        name: '',
        equipment_model: '',
        stg_id: '',
        install_location: '',
        longitude: 0,
        latitude: 0,
        is_support_offline_stg: '',
        loop_device_json: [
          {
            loop_number: 1,
            bind_type: 0,
            bind_device_id: 0,
            device_list: []
          },
          {
            loop_number: 2,
            bind_type: 0,
            bind_device_id: 0,
            device_list: []
          },
          {
            loop_number: 3,
            bind_type: 0,
            bind_device_id: 0,
            device_list: []
          },
          {
            loop_number: 4,
            bind_type: 0,
            bind_device_id: 0,
            device_list: []
          },
          {
            loop_number: 5,
            bind_type: 0,
            bind_device_id: 0,
            device_list: []
          },
          {
            loop_number: 6,
            bind_type: 0,
            bind_device_id: 0,
            device_list: []
          }
        ]
      },
      lampLoop: {
        id: null,
        dialogVisible: false,
        name: ''
      },
      groupSelectionInfo: {
        id: '',
        step: 1,
        number: '',
        name: '',
        equipment_model: null,
        stg_id: '',
        install_location: '',
        longitude: 0,
        latitude: 0,
        is_support_offline_stg: '',
        loop_device_json: ''
      },
      deviceControl: {
        visible: false,
        title: '',
        type: 1,
        deviceList: [],
        cmdState: 0 // 0.未发送执行  1.已发送命令  2.已完成
      },
      reasonData: {
        visible: false,
        heart: ''
      },
      recoveryData: {
        visible: false,
        id: null,
        stg_id: '',
        strategy_name: '',
        ms: 0,
        new_stg_id: 0
      }
    };
  },
  computed: {
    dialogTitle: function () {
      if(this.editType === 'create'){
        if(this.editOne.step==1){
          return '添加集控 | 基础信息'
        }else{
          return '添加集控 | 回路控制'
        }
      }else{
        if(this.editOne.step==1){
          return '修改集控 | 基础信息'
        }else{
          return '修改集控 | 回路控制'
        }
      }
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
    this.getStrategyList();
  },
  methods: {
    getTableData(pageIndex) {
      // 获取列表
      this.pageInfo.page = pageIndex;
      this.loading = true;
      concentratorApi.concentratorList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          const resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },
    getStrategyList(){
      strategyApi.strategyList({
        page: 1,
        pageSize: 100
      }).then((res) => {
        if (res.data.code === 1000) {
          const resData = res.data.data;
          this.strategyList = resData.list;
        }
      })
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    headSearch() {
      this.pageInfo.page = 1
      this.pageInfo.pageSize = 10
      this.getTableData(1)
    },
    selectionDevice(val) {
      if (val.length > 1) {
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val[val.length - 1]);
      }
      this.groupSelectionInfo = val[val.length - 1]
      if(!this.groupSelectionInfo) {
        this.groupSelectionInfo = {
          id: '',
          step: 1,
          number: '',
          name: '',
          equipment_model: null,
          stg_id: '',
          install_location: '',
          longitude: 0,
          latitude: 0,
          is_support_offline_stg: '',
          loop_device_json: ''
        }
      }
    },
    concentratorContorls(type) {
      if(!this.groupSelectionInfo.id) return this.$message.error('请先勾选设备！');
      console.log('concentratorContorls', this.groupSelectionInfo)
      const deviceListStr = this.groupSelectionInfo.loop_device_json
      let deviceList = []
      if(deviceListStr){
        deviceList = JSON.parse(deviceListStr);
      }
      if(deviceList.length<1){
        this.$popupMessage({
          type: 'error',
          title: "该集控下未绑定设备！",
          msg: '请先给该集控绑定路灯或其他设备！'
        })
        return
      }
      // deviceList = deviceList.map(item => ({ ...item, flag: null }));
      
      this.deviceControl= {
        id: this.groupSelectionInfo.id,
        visible: true,
        title: `手动模式 | 一键${type ? '全开' : '全关'}`,
        type,
        deviceList,
        cmdState: 0   // 0.未发送执行  1.已发送命令  2.已完成  3.失败
      }

      setTimeout(() => {
        this.deviceControl.cmdState = 1
        this.manualSwitchControl(1, this.deviceControl.id, type, '')
      }, 1000);
    },
    manualSwitchControl(type, cids, switch_type, loop_ids){
      concentratorApi.manualSwitchCenter({
        type,
        cids,
        switch: switch_type,
        loop_ids
      }).then((res) => {
        if (res.data.code === 1000) {
          setTimeout(() => {
            this.deviceControl.cmdState = 2
          }, 1000);
        } else {
          this.deviceControl.cmdState = 3
          this.$message.error(res.data.message);
        }
      });
    },
    deviceControlClose(){
      this.deviceControl = {
        visible: false,
        title: '',
        type: 1,
        deviceList: [],
        cmdState: 0  // 0.未发送执行  1.已发送命令  2.已完成
      },
      this.$refs.table.clearSelection()
      this.getTableData(this.pageInfo.page);
    },
    recoveryWin(row){
      this.recoveryData = {
        visible: true,
        id: row.id,
        stg_id: row.stg_id,
        strategy_name: row.strategy_name,
        ms: row.ms,
        new_stg_id: row.stg_id
      }
    },
    viewReason(last_ping){
      this.reasonData.visible = true
      this.reasonData.last_ping =  this.$commonJs.formatDate(last_ping*1000)
    },
    setRecoveryStrategy(id){  //还原策略
      let params = {
        id: id,
        stg_id: this.recoveryData.new_stg_id
      }
      concentratorApi.recoveryStrategy(params).then((res) => {
        if (res.data.code === 1000) {
          this.recoveryData.visible =false
          this.$popupMessage({
            type: 'success',
            title: "恢复成功"
          })
          this.getTableData(this.pageInfo.page);
        } else {
          this.$popupMessage({
            type: 'error',
            title: "提示",
            msg: res.data.message,
          })
        }
      })
    },
    getRowKey (row) {
      return row.id
    },
    checkNoSelect(row, index) {
      let isChecked = false
      if (row.ste==1) {
        isChecked = true
      }
      return isChecked
    },
    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          id: '',
          step: 1,
          number: '',
          name: '',
          equipment_model: null,
          stg_id: '',
          install_location: '',
          longitude: 0,
          latitude: 0,
          is_support_offline_stg: '',
          loop_device_json: [
            {
              loop_number: 1,
              bind_type: 0,
              bind_device_id: 0,
              device_list: []
            },
            {
              loop_number: 2,
              bind_type: 0,
              bind_device_id: 0,
              device_list: []
            },
            {
              loop_number: 3,
              bind_type: 0,
              bind_device_id: 0,
              device_list: []
            },
            {
              loop_number: 4,
              bind_type: 0,
              bind_device_id: 0,
              device_list: []
            },
            {
              loop_number: 5,
              bind_type: 0,
              bind_device_id: 0,
              device_list: []
            },
            {
              loop_number: 6,
              bind_type: 0,
              bind_device_id: 0,
              device_list: []
            }
          ]
        };
        let address = store.state.user.account.address
        if(address){
          this.editOne.install_location = address
        }
        let lngLat = store.state.user.account.center
        if(lngLat&&lngLat.length){
          this.editOne.longitude = lngLat[0]
          this.editOne.latitude = lngLat[1]
        } 
        this.editType = "create"
        this.dialogVisible = true;
      } else {
        
        this.editOne = {
          id: index.id,
          step: 1,
          number: index.number,
          name: index.name,
          equipment_model: index.equipment_model,
          stg_id: index.stg_id,
          install_location: index.install_location,
          longitude: index.longitude,
          latitude: index.latitude,
          is_support_offline_stg: index.is_support_offline_stg,
          loop_device_json: []
        };
        
        let lng = index.longitude
        let lat = index.latitude
        let lngLat = [lng, lat]
        if(!lng&&!lat){
          lngLat = store.state.user.account.center
          this.editOne.longitude = lngLat[0]
          this.editOne.latitude = lngLat[1]
          
        }
        const loop_device_json = index.loop_device_json
        if(loop_device_json){
          this.getLoopData(loop_device_json)
        }else{
          this.editOne.loop_device_json = [
            {
              loop_number: 1,
              bind_type: 0,
              bind_device_id: 0,
              device_list: []
            },
            {
              loop_number: 2,
              bind_type: 0,
              bind_device_id: 0,
              device_list: []
            },
            {
              loop_number: 3,
              bind_type: 0,
              bind_device_id: 0,
              device_list: []
            },
            {
              loop_number: 4,
              bind_type: 0,
              bind_device_id: 0,
              device_list: []
            },
            {
              loop_number: 5,
              bind_type: 0,
              bind_device_id: 0,
              device_list: []
            },
            {
              loop_number: 6,
              bind_type: 0,
              bind_device_id: 0,
              device_list: []
            }
          ]
          this.dialogVisible = true;
        }
        this.editType = "update"
      }
      
    },
    async getLoopData(arr_str) {
      let arr = []
      if(arr_str){
        arr = JSON.parse(arr_str);
      }
      for (let i=0; i<arr.length; i++) {
        await this.getDeviceListByType(arr[i].bind_type).then(deviceList => {
          const item_one = {
            loop_number: arr[i].loop_number,
            bind_type: arr[i].bind_type,
            bind_device_id: arr[i].bind_device_id,
            device_list: deviceList
          }
          this.$set(this.editOne.loop_device_json, i, item_one)
          if(i==5){
            this.dialogVisible = true
          }
        })
      }
    },
    async changeType(e, index) {
      let item_one = {
        loop_number: index+1,
        bind_type: e,
        bind_device_id: 0,
        device_list: []
      }
      if(e){
        await this.getDeviceListByType(e).then(deviceList => {
          item_one.device_list = deviceList
          this.$set(this.editOne.loop_device_json, index, item_one)
        })
      }else{
        this.$set(this.editOne.loop_device_json, index, item_one)
      }
    },
    async getDeviceListByType(type) {
      if (!type) {
        return [];
      }
      try {
        const res = await concentratorApi.getDeviceListByDeviceType({
          bind_type: type
        });
        if (res.data.code === 1000) {
          const resData = res.data.data;
          if (resData && resData.length) {
            return resData;
          } else {
            return []
          }
        } else {
          return []
        }
      } catch (error) {
        return []
      }
    },
    updateItem() {
      const loop_device_json = this.editOne.loop_device_json
      let params = {
        number: this.editOne.number,
        name: this.editOne.name,
        equipment_model: this.editOne.equipment_model,
        stg_id: this.editOne.stg_id,
        install_location: this.editOne.install_location,
        longitude: this.editOne.longitude,
        latitude: this.editOne.latitude,
        is_support_offline_stg: this.editOne.is_support_offline_stg,
        loop_device_json: []
      }

      let new_loop_device_json= []
      for(let i =0; i<loop_device_json.length; i++){
        const item_one = {
          loop_number: loop_device_json[i].loop_number,
          bind_type: loop_device_json[i].bind_type,
          bind_device_id: loop_device_json[i].bind_device_id
        }
        new_loop_device_json[i] = item_one
      }
      params.loop_device_json = JSON.stringify(new_loop_device_json);
      console.log('params', params)
      concentratorApi.concentratorEdit(this.editOne.id, params).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("修改成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createItem() {
      const loop_device_json = this.editOne.loop_device_json
      let params = {
        number: this.editOne.number,
        name: this.editOne.name,
        equipment_model: this.editOne.equipment_model,
        stg_id: this.editOne.stg_id,
        install_location: this.editOne.install_location,
        longitude: this.editOne.longitude,
        latitude: this.editOne.latitude,
        is_support_offline_stg: this.editOne.is_support_offline_stg,
        loop_device_json: []
      }

      let new_loop_device_json= []
      for(let i =0; i<loop_device_json.length; i++){
        const item_one = {
          loop_number: loop_device_json[i].loop_number,
          bind_type: loop_device_json[i].bind_type,
          bind_device_id: loop_device_json[i].bind_device_id
        }
        new_loop_device_json[i] = item_one
      }
      params.loop_device_json = JSON.stringify(new_loop_device_json);
      concentratorApi.concentratorAdd(params).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("添加成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          concentratorApi.concentratorDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("删除成功");
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleMove() {
      this.myMap.markercenter = this.$refs.map.$$getCenter();
      this.editOne.longitude = this.myMap.markercenter[0];
      this.editOne.latitude = this.myMap.markercenter[1];
    },
    // 回路控制
    openLampLoop(row) {
      this.lampLoop = {
        id: row.id,
        dialogVisible: true,
        name: row.name
      }
    },
    closeLampLoop() {
      this.lampLoop = {
        id: null,
        dialogVisible: false,
        name: ''
      }
    },
    groupNext(step){
      this.$refs.editOneRef.validate((valid) => {
        if (valid) {
          this.editOne.step=step
        } else {
          return false
        }
      })
    },
    getCoordinate(map) {
      this.editOne.longitude = map.lng
      this.editOne.latitude = map.lat
      if(map.address){
        this.editOne.install_location = map.address
      }
    },
    filterSteList(list) {
      return list.filter((t, index) => index !== 0);
    },
    onInput() {
      this.$forceUpdate();
    }
  }
};
</script>
<style lang='less'>
.concentrator-list {
  width: 100%;
  .con-body{
    width:100%;
    box-sizing: border-box;
    height: calc(100vh - 210px);
  }
  .map-container {
    padding-left: 100px;
    height: 180px;
    margin-bottom: 10px;
  }
  

  .edit-table{
    color:#1d2129;
    padding-bottom: 20px;
    .sub-title{
      padding-bottom: 15px;
    }
    .t-head{
      width:100%;
      margin: 0;
      padding: 0;
      display: flex;
      align-items: center;
      background-color: #f6f7fb;
      box-sizing: border-box;
      li{
        height:40px;
        display: flex;
        align-items: center;
        justify-content: center;
        &.bh{
          width:60px;
        }
        &.loop{
          width:140px;
        }
        &.time{
          flex: 1;
          min-width: 150px;
        }
      }
    }

    .item-box{
      width:100%;
      border-bottom: 1px solid #dcdee2;
      align-items: stretch;
      padding: 15px 0;
      .item{
        display: flex;
        .bh{
          width:60px;
          display:flex;
          align-items:center;
          justify-content:center;
          padding:0 10px;
          box-sizing: border-box;
        }
        .loop{
          width:140px;
          display:flex;
          align-items:center;
          justify-content:center;
          padding:0 10px;
          box-sizing: border-box;
        }
        .time{
          flex: 1;
          min-width: 150px;
          display:flex;
          align-items:center;
          justify-content:center;
          padding:0 10px;
          box-sizing: border-box;
          .el-input__inner{
            position:relative;
            text-align: center;
            height:38px !important;
            line-height: 38px !important;
          }
        }
      }
    }
  }


  .box_control {
    width: 600px !important;
    height: auto !important;
    margin-top: -200px !important;
    margin-left: -300px !important;
    .box_body {
      padding-bottom: 25px;
    }
  }
  .box_control_bg{
    transition: all 0.5s;
    &.pack-up{
      width:0;
      height:0;
      overflow: hidden;
    }
  }

  .device-control{
    width: 860px !important;
    height: auto !important;
    top: 0 !important;
    margin-top: 130px !important;
    margin-left: -430px !important;
    color: #333 !important;
    transition: all 0.3s;
    opacity: 1;
    .box_body {
      padding:60px;
      transition: all 1s;
      .box_con{
        padding-bottom: 40px;
        padding: relative;
        display: block;
        box-sizing: border-box;
        width:740px;
        .box_title{
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 10px 10px 20px;
          color:#1d2129;
          font-size: 24px;
          font-weight: 600;
        }
        .right-close{
          position: absolute;
          color:#898ea1;
          right:30px;
          top:30px;
          font-size: 20px;
          cursor: pointer;
        }
        .device-control-tip{
          padding: 10px 0;
          font-size: 14px;
        }
        .device-control-list{
          margin: 0  -25px;
          height:200px;
          overflow-y: auto;
          &::before, &::after {
            content: " ";
            display: table;
          }
          &::after {
            clear: both;
          }
          .item-one{
            width:50%;
            float: left;
            box-sizing: border-box;
            padding: 8px 25px;
            .item-one-pad{
              border-radius: 3px;
              border: 1px solid #ff8b23;
              display: flex;
              align-items: center;
              position: relative;
              padding: 12px 15px;
              box-sizing: border-box;
              .item-icon{
                font-size: 25px;
                color: #ff8b23;
                margin-right: 10px;
                display: flex;
                align-items: center;
                img{
                  width:26px;
                  height:auto;
                }
              }
              .item-title{
                width:200px;
                font-size: 14px;
                color: #555;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
              }
              .item-close{
                font-size: 21px;
                color: #ff8b23;
                position: absolute;
                right:15px;
                top:50%;
                transform: translate(0,-50%);
                cursor: pointer;
              }

              .item-cmd{
                font-size: 14px;
                position: absolute;
                right:15px;
                top:50%;
                transform: translate(0,-50%);
                cursor: pointer;
              }
            }
          }
        }
       

      }
    }
  }

  .reason-box{
    width:542px !important;
    height:480px !important;
    background:url(../../../assets/images/reason_bg.jpg) center center no-repeat #f0f6fa;
    background-size: 100% 100%;
    .box_con{
      padding: 30px 35px;
      .box_title{
        display: flex;
        height: 60px;
        color:#2d8cf0;
        justify-content: center;
        font-size:28px;
        i{
          font-size:32px;
        }
        span{
          margin-left:10px;
          font-weight:bold;
        }
      }
      .con-text{
        padding:20px 0 10px;
        color:#86909c;
        font-size:14px;
        line-height:1.6;
        .item-title,.item-heart{
          font-size:16px;
          font-weight:bold;
          margin-top:12px;
          height:32px;
          position:relative;
          padding-left:12px;
          display:flex;
          align-items:center;
          color:#1d2129;
          &::before{
            content:'';
            width:6px;
            height:6px;
            background:#2d8cf0;
            border-radius:6px;
            position:absolute;
            left:0;
            top:50%;
            margin-top:-4px;
          }
        }
        .item-heart{
          color:#2d8cf0;
          height:50px;
        }
        .item{
          padding-left:12px;
        }
      }
    }
    .box-footer{
      justify-content:center !important;
      .el-button--medium{
        padding-left:60px;
        padding-right:60px;
      }
    }
  }

  .form-info{
    padding: 0 22px 0 15px;
    .map-box{
      padding-left: 20px;
    }
    .el-form-item__label{
      width:85px;
      white-space: nowrap;
    }
  }
}

</style>
